import { CSSObject, Theme } from '@mui/material';
import { themeVars } from './themeVars';

const width = 16;
const margin = 2;

/**
 * Standard scrollbar properties do not support thumb margin and border radius.
 *
 * Writing the following would make cause Chrome to ignore non-standard Webkit properties:
 * ```
 * '@supports (scrollbar-width: auto)': {
 *   scrollbarColor: `${theme.vars.palette.scrollbar.thumb} ${theme.vars.palette.scrollbar.track}`,
 * },
 * ```
 */
export const scrollbarStyles = (theme: Theme): CSSObject => ({
  '@supports selector(::-webkit-scrollbar)': {
    '::-webkit-scrollbar': {
      width: width - margin * 2,
      height: width - margin * 2,
    },
    '::-webkit-scrollbar-thumb': {
      background: themeVars(theme).palette.scrollbar.thumb,
      border: `${margin}px solid rgba(0, 0, 0, 0)`,
      borderRadius: `calc(${margin + 2}px + ${themeVars(theme).shape.borderRadius})`,
      backgroundClip: 'padding-box',
    },
    '::-webkit-scrollbar-track': {
      background: themeVars(theme).palette.scrollbar.track,
    },
    '::-webkit-scrollbar-corner': {
      background: themeVars(theme).palette.scrollbar.track,
    },
  },
});
